import { render } from "./dikelolaSwasta.vue?vue&type=template&id=09190d8e"
import script from "./dikelolaSwasta.vue?vue&type=script&lang=js"
export * from "./dikelolaSwasta.vue?vue&type=script&lang=js"

import "./dikelolaSwasta.vue?vue&type=style&index=0&id=09190d8e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__